import WpNamedThemeFilters from '@nematis/hooks/lib/presets/wp-named-theme-filters'

export default class AlphaFilters extends WpNamedThemeFilters {
  static getFilterTypeName() {
    return 'alpha'
  }
}
